<template>
  <div class="myReceive">
    <template v-if="receiveList.length">
      <div
        v-for="item in receiveList"
        :key="item.id"
        class="taskItem flex-center"
        @click="$router.push('/get?type=2&taskId=' + item.task_id)"
      >
        <van-image class="taskImg" :src="require('../../../assets/image/tags/qita.png')" />
        <div class="taskRight">
          <h5>
            {{ item.title }} <span>{{ item.status_text }}</span>
          </h5>
          <div class="labels flex-center">
            <div class="label fontCenter color1">
              {{ item.task_mech }}
            </div>
            <template v-if="item.task_tag">
              <div
                class="label fontCenter color2"
                v-for="(childItem, childIndex) in strToArr(item.task_tag)"
                :key="childIndex"
              >
                {{ childItem }}
              </div>
            </template>

            <div
              class="label fontCenter color3"
              v-if="item.urgent_level == '紧急'"
            >
              {{ item.urgent_level }}
            </div>
          </div>
          <p class="flex-center">
            <span>{{ item.plan_start_time }}-{{ item.plan_end_time }}</span>
            <span class="delay">已延期</span>
          </p>
          <div class="taskBottom flex-center">
            <div class="prise">
              <img src="@/assets/image/prise.png" alt="" />
              <span>{{ moneyFormat(item.award) }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <nothing-com v-else></nothing-com>
  </div>
</template>

<script>
import { getMyTasksApi } from "@/api/api/task.js";
export default {
  name: "myReceive", //我的领取页面组件

  props: {
    status: {},
  },
  watch: {
    status() {
      this.getData();
    },
  },
  data() {
    return {
      receiveList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let res = await getMyTasksApi(this.status);
      console.log('我的已领取',res);
      this.receiveList = res.data.data.list;
    },
  },
};
</script>

<style lang="scss" scoped>
.myReceive {
  padding-top: 22px;
}
.taskItem {
  height: 100px;
  margin-bottom: 36px;
  padding: 0 15px;

  .taskImg {
    width: 100px;
    height: 100px;
  }
  .taskRight {
    flex: 1;
    margin-left: 13px;
    height: 100%;
    border-bottom: 1px solid #d8d8d8;
    h5 {
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      align-content: center;
      span {
        font-weight: normal;
        color: #0286ff;
        font-size: 12px;
      }
    } 

    .labels {
      margin-top: 5px;
      justify-content: flex-start;
      .label {
        padding: 0 6px;
        height: 16px;
        font-size: 10px;
        color: #ffffff;
        margin-right: 5px;
        border-radius: 50%;
      }
    }
    p {
      font-size: 11px;
      color: #979797;
      margin-top: 8px;
      height: 15px;
      line-height: 15px;
      justify-content: flex-start;
      .delay {
        color: #f91400;
        margin-left: 8px;
      }
    }
    .taskBottom {
      justify-content: space-between;
      margin-top: 8px;
      .prise {
        display: flex;
        align-items: center;
        img {
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }
      }
      .receive {
        padding: 0 8px;
        height: 20px;
        background: #ff7a15;
        border-radius: 11px;
        font-size: 12px;
        color: #fff;
      }
    }
  }
}
</style>